module.exports = __webpack_public_path__ + "img/personal-possessions.e8b3cb4d.png";